import React from 'react';
import { modules, OFFER_ANCHOR } from '../data/electrical';
export function ModulesSection() {
  return <section className="bg-tech px-4 py-4 sm:py-6" data-id="element-94" data-mp="1nuebxjml0bkz">
      <div className="mx-auto max-w-4xl" data-id="element-95" data-mp="1nstjbzjtv2pr">
        <h2 className="text-center text-lg leading-tight text-navy sm:text-3xl" data-id="element-96" data-mp="1ius2ll9vjfhg">
          WHAT’S INSIDE
        </h2>

        <div className="mt-2 grid gap-1.5 sm:grid-cols-2" data-id="element-97" data-mp="1dxt6wyakb0h5">
          {modules.map(module => <a key={module.num} href={OFFER_ANCHOR} className="flex flex-col rounded-lg border border-navy/10 bg-white p-2.5 shadow-sm transition-colors duration-150 hover:border-volt" data-id="element-98" data-mp="2bixo4a8r58ic">
              <p className="font-head text-[11px] font-extrabold uppercase tracking-wide text-navy" data-id="element-99" data-mp="21nvyzeeh86fr">
                ✅ MODULE {module.num}
              </p>
              <h3 className="mt-0.5 text-[15px] leading-tight text-navy sm:text-lg" data-id="element-100" data-mp="q7p42t5774r7">
                {module.title}
              </h3>
              {module.body.map(paragraph => <p key={paragraph} className="mt-1 text-[13px] font-medium leading-snug text-carbon/80" data-id="element-101" data-mp="1iwa4g97qetpd">
                  {paragraph}
                </p>)}
              <p className="mt-auto pt-1.5 font-head text-[13px] font-extrabold uppercase text-navy" data-id="element-102" data-mp="18wj61wg1vuk0">
                {module.kicker}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}